import Wrapper from "./Wrapper";
import OfferPageSection from "../../components/OfferPage";
const OfferPage = () => {
  return (
    <Wrapper>
      <div className="main_div">
        <h2 className="main_heading">OFFER.</h2>
      </div>
      <OfferPageSection />
    </Wrapper>
  );
};
export default OfferPage;
